import React from "react";
import { FaYoutube, FaInstagram, FaFacebookF } from "react-icons/fa";
import { instructors } from "../../constants";

const Instructors = () => {
  return (
    <div className="w-full mx-auto">
      <div className="max-w-screen-2xl py-10 mx-auto borer-b-[1px] border-b border-b-primeColor">
        <div className="flex flex-col justify-center gap-2 items-center">
          <h1 className="text-6xl font-titleFont font-bold text-primeColor ">
            Instructors
          </h1>
          <span className="w-32 h-1 bg-primeColor inline-block"></span>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 place-items-center xl:grid-cols-5 gap-4 px-4 py-10">
          {instructors.map((instructor) => (
            <div
              key={instructor.id}
              className="flex flex-col gap-2 border-[1px] border-gray-300 hover:border-primeColor transition-hover duration-300"
            >
              <div className="w-full h-[270px] relative overflow-hidden group">
                <img
                  className="w-80 h-[300px] object-cover"
                  src={instructor.Image}
                  alt="instructorsOne"
                />
                <div className="absolute flex bg-darkPink bg-opacity-90 top-0 left-0 -translate-x-[100%] group-hover:translate-x-0 transition-transform duration-300 w-full h-full py-6 px-4 flex-col justify-center text-center items-center gap-4 text-white font-bodyFont cursor-pointer">
                  <p className="text-sm text-left tracking-wide leading-5">
                    {instructor.hoverDes}
                  </p>
                  <p className="text-sm text-left tracking-wide leading-5">
                    <span className="font-semibold underline underline-offset-4 mr-2">
                      Expertise Area :
                    </span>
                    {instructor.hoverReadMore}
                  </p>
                </div>
              </div>
              <div className="p-4">
                <div className="flex flex-col justify-center items-center">
                  <h3 className="font-titleFont text-xl font-semibold">
                    {instructor.title}
                  </h3>
                  <p className="font-bodyFont text-[14px]">
                    {instructor.subject}
                  </p>
                </div>
                <div>
                  <ul className="flex flex-row justify-center gap-2">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.facebook.com/educareenglishlearningacademy/"
                    >
                      <li className="w-10 h-10 bg-primeColor rounded-full flex justify-center items-center hover:bg-darkPink duration-300 cursor-pointer transition-hover">
                        <FaFacebookF className="text-white text-xl rounded-full" />
                      </li>
                    </a>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https:www.youtube.com/channel/UCcci_0jFRNEVQSBXTgyodZA/"
                    >
                      <li className="w-10 h-10 bg-primeColor rounded-full flex justify-center items-center hover:bg-darkPink duration-300 cursor-pointer">
                        <FaYoutube className="text-white text-xl rounded-full" />
                      </li>
                    </a>
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://www.instagram.com/educare_englishlearningacademy/"
                    >
                      <li className="w-10 h-10 bg-primeColor rounded-full flex justify-center items-center hover:bg-darkPink duration-300 cursor-pointer">
                        <FaInstagram className="text-white text-xl rounded-full" />
                      </li>
                    </a>
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Instructors;
